var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12.75c1.45-.88 2.5-3.03 2.5-4.75 0-2.73-2.55-5-5.5-5S6.5 5.27 6.5 8c0 2.5 1 3.87 2.44 4.75m6.06 0a5.8 5.8 0 0 1-3 .75 6.01 6.01 0 0 1-3.06-.75m6.06 0c2.52 0 6.33 4.44 4.9 7.49-.25.52-.84.76-1.42.76H5.62c-.66 0-1.31-.32-1.5-.95-.9-3.03 2.35-7.3 4.82-7.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser24);
export default __webpack_public_path__ + "static/media/user_24.b845c8a24579212255d6ea7b88f21f54.svg";
export { ForwardRef as ReactComponent };